function errorAuth(data) {
  return {
    type: 'AUTH_PAGE_ERROR',
    data,
  };
}

export {errorAuth};
